module.exports = (__webpack_require__(8))(152);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/TimelineWidget.js from dll-reference girder_lib
// module id = 961
// module chunks = 0